import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';

const FormError = ({
  error,
  iconSize = 35,
  fontSize = 14,
  color = Theme.CHARCOAL
}) => (error ? (
  <View style={styles.container}>
    <Icon
      size={iconSize}
      color={color}
      name="ios-alert-outline"
      style={styles.icon}
    />
    <Text style={[styles.message, { color, fontSize }]}>
      {error.message}
    </Text>
  </View>
) : (
    <View />
  ));

const styles = StyleSheet.create({
  container: {
    padding: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: {
    paddingRight: 10,
  },
  message: {
    flex: 1,
    fontSize: 14,
    flexWrap: 'wrap',
    fontFamily: Theme.CustomBold,
    paddingVertical: 3,
  },
});


export default FormError;
